@layer ch-grid {
  ch-grid-virtual-scroller {
    display: contents;
  }

  ch-grid-virtual-scroller::after {
    content: "";
    display: block;
    height: var(--ch-grid-virtual-scroller-height, 0px);
  }

  .virtual-scroller-row-size {
    grid-column: 1/-1;
    grid-row: 1/span 3;
  }
}